/**
 * Interface for receipt component
 */

export interface Receipt {
  name: string;
  group: string;
  cost: number;
}

export enum ReceiptSizes {
  small = 'small',
  large = 'large',
}

export interface ReceiptConfiguration {
  billDescription: string;
  isTotalDisplayed: boolean;
  isNameDisplayed: boolean;
  isSubtotalDisplayed?: boolean;
  isGroupNameDisplayed?: boolean;
  size?: ReceiptSizes;
  groupLabel?: string;
}

export interface ReceiptBillDetails {
  lastPaidAmount: string;
  lastPaidDate: string;
  summary: {
    label: string;
    value: string;
  }[];
}

export interface ReceiptArgs {
  data: Receipt[];
  config: ReceiptConfiguration;
}
